export var IngredientUnits;
(function (IngredientUnits) {
    IngredientUnits["KG"] = "kg";
    IngredientUnits["L"] = "l";
    IngredientUnits["UD"] = "ud";
})(IngredientUnits || (IngredientUnits = {}));
export var IngredientDisplayUnits;
(function (IngredientDisplayUnits) {
    IngredientDisplayUnits["KG"] = "kg";
    IngredientDisplayUnits["L"] = "l";
    IngredientDisplayUnits["UD"] = "ud";
    IngredientDisplayUnits["G"] = "g";
    IngredientDisplayUnits["ML"] = "ml";
})(IngredientDisplayUnits || (IngredientDisplayUnits = {}));
export var IngredientLongDisplayUnits;
(function (IngredientLongDisplayUnits) {
    IngredientLongDisplayUnits["KG"] = "kilogramo";
    IngredientLongDisplayUnits["KG_PLURAL"] = "kilogramos";
    IngredientLongDisplayUnits["L"] = "litro";
    IngredientLongDisplayUnits["L_PLURAL"] = "litros";
    IngredientLongDisplayUnits["UD"] = "unidad";
    IngredientLongDisplayUnits["UD_PLURAL"] = "unidades";
    IngredientLongDisplayUnits["G"] = "gramo";
    IngredientLongDisplayUnits["G_PLURAL"] = "gramos";
    IngredientLongDisplayUnits["ML"] = "mililitro";
    IngredientLongDisplayUnits["ML_PLURAL"] = "mililitros";
})(IngredientLongDisplayUnits || (IngredientLongDisplayUnits = {}));
export var SellableIngredientCategory;
(function (SellableIngredientCategory) {
    SellableIngredientCategory["Wine"] = "Wine";
    SellableIngredientCategory["Beer"] = "Beer";
    SellableIngredientCategory["NonAlcohol"] = "NonAlcohol";
    SellableIngredientCategory["Generic"] = "Generic";
})(SellableIngredientCategory || (SellableIngredientCategory = {}));
export const normalizeSellableIngredientCategory = (category) => {
    if (category == null) {
        return null;
    }
    if (Object.values(SellableIngredientCategory).includes(category)) {
        return category;
    }
    return null;
};
export const DEFAULT_INGREDIENT_SELLABLE = {
    enabled: false,
    pvp: null,
    pvpGlass: null,
    pvpBottle: null,
};
export const CREATE_NEW_INGREDIENT_ID = 'new';
export const USE_DEFAULT_INGREDIENT_ID = 'supplier-default';
export const DELETED_INGREDIENT_ID = 'deleted';
//# sourceMappingURL=IngredientEntity.js.map